import { AdminRoutes } from "./private/admin";
import { ClientRoutes } from "./private/client";

export const PrivateRoutes = [...ClientRoutes, ...AdminRoutes];
